export enum BundleBoxPlpSliderLocation {
    Kurzurlaub = 'g6ukx',
    ForCouples = 'g2oad',
}
